import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Phone from 'react-phone-number-input';
import { makeStyles } from '@material-ui/core';
import { getHelpOrError, hasError } from './_common';

const styles = makeStyles((theme) => ({
  root: {
    '& div': {
      '&:focus-visible': {
        outlineOffset: 'unset',
        outline: 'unset',
      },
    },

    '& input': {
      font: 'inherit',
      color: 'currentColor',
      width: '100%',
      border: '0',
      height: '1.1876em',
      margin: '0',
      display: 'block',
      padding: '6px 0px 7px 5px',
      fontSize: '16px',
      lineHeight: '19px',
      minWidth: '0',
      background: 'none',
      boxSizing: 'content-box',
      animationName: 'mui-auto-fill-cancel',
      letterSpacing: 'inherit',
      animationDuration: '10ms',
      '-webkit-tap-highlight-color': 'transparent',
      transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      borderBottom: '1px solid rgba(0, 0, 0, 0.42)',

      '&:hover': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.8)',
      },

      '&:focus-visible': {
        outlineOffset: 'unset',
        outline: 'unset',
      },

      '&:focus': {
        borderBottom: `1px solid ${theme.palette.primary.main}`,
      },
    },
  },
}));

const FormPhone = ({
  onChange,
  onBlur,
  value,
  name,
  style,
  required,
  errors,
  help,
  ...rest
}) => {
  const classes = styles();

  return (
    <FormControl fullWidth margin="none" style={{ marginTop: '8px', ...style }} required={required}>
      <Phone
        defaultCountry="SE"
        locales="SV"
        autoComplete="off"
        className={classes.root}
        onChange={(v) => {
          return onChange(v || null);
        }}
        onBlur={onBlur}
        value={value}
        name={name}
        {...rest}
      />
      <FormHelperText error={hasError(errors, name)}>
        <span>{getHelpOrError(help, errors, name)}</span>
      </FormHelperText>
    </FormControl>
  );
};

FormPhone.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  style: PropTypes.shape({}),
  label: PropTypes.node,
  required: PropTypes.bool,
  errors: PropTypes.shape({}),
  help: PropTypes.node,
};

export default FormPhone;
